/** Saves rows as a CSV download. Every field is quoted, so names containing a
 * comma cannot shift the columns. */
export function downloadCsv(filename: string, lines: (string | number)[][]): void {
  const csv = lines
    .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(','))
    .join('\n')
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }))
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
